export const TaskTypes = {
    BugReport: 1,
    ImprovementProposal: 2,
    DevelopmentDiary: 3
};